import React from "react";
import styled from "styled-components";
import PropTypes from "prop-types";
import theme from "styled-theming";

const burstBackgroundColor = theme.variants("mode", "variant", {
  neutral: {
    light: "#808080",
    dark: "#808080",
  },
  secondary: {
    light: (props) => props.theme.colors.secondary.main.color,
    dark: (props) => props.theme.colors.secondary.main.color,
  },
  primary: {
    light: (props) => props.theme.colors.primary.main.color,
    dark: (props) => props.theme.colors.primary.main.color,
  },
  "primary.dark": {
    light: (props) => props.theme.colors.primary.dark.color,
    dark: (props) => props.theme.colors.primary.dark.color,
  },
});

const burstTextColor = theme.variants("mode", "variant", {
  neutral: {
    light: "white",
    dark: "white",
  },
  secondary: {
    light: (props) => props.theme.colors.secondary.main.contrastColor,
    dark: (props) => props.theme.colors.secondary.main.contrastColor,
  },
  primary: {
    light: (props) => props.theme.colors.primary.main.contrastColor,
    dark: (props) => props.theme.colors.primary.main.contrastColor,
  },
  "primary.dark": {
    light: (props) => props.theme.colors.primary.dark.contrastColor,
    dark: (props) => props.theme.colors.primary.dark.contrastColor,
  },
});

const PointBurstDefault = styled.div`
  position: absolute;
  background-color: ${burstBackgroundColor};
  color: ${burstTextColor};
  height: ${(props) => props.size}px;
  width: ${(props) => props.size}px;
  font-size: 36px;
  text-align: center;
  white-space: nowrap;
  display: flex;
  justify-content: center;
  align-items: center;
  span {
    color: ${burstTextColor} !important;
  }
`;

PointBurstDefault.defaultProps = {
  variant: "primary",
};

const PointBurst30 = styled(PointBurstDefault)`
  transform: rotate(30deg);
`;

const PointBurst60 = styled(PointBurstDefault)`
  transform: rotate(60deg);
`;

// Circular variant — a single round badge instead of the stacked rotated
// squares that form the star burst. Used by the dynamic-package-graphics
// card layout; the default "burst" shape is unchanged for all other callers.
const PointBurstCircle = styled(PointBurstDefault)`
  border-radius: 50%;
`;

class PointBurst extends React.Component {
  constructor(props) {
    super(props);
  }

  render() {
    const { content, variant, size, shape } = this.props;

    if (shape === "circle") {
      return (
        <PointBurstCircle variant={variant} size={size}>
          {content}
        </PointBurstCircle>
      );
    }

    return (
      <React.Fragment>
        <PointBurst30 variant={variant} size={size} />
        <PointBurst60 variant={variant} size={size} />
        <PointBurstDefault variant={variant} size={size}>
          {content}
        </PointBurstDefault>
      </React.Fragment>
    );
  }
}

PointBurst.propTypes = {
  content: PropTypes.object.isRequired,
  size: PropTypes.optionalNumber,
  shape: PropTypes.oneOf(["burst", "circle"]),
};

PointBurst.defaultProps = {
  variant: "primary",
  size: 80,
  shape: "burst",
};

export default PointBurst;
